import { injectIntl, defineMessages } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { START_CALL_FORM } from 'constants/StartCallModal';
import PillComp from 'components/Pill/Pill';
import classes from './StartCallModal.module.scss';
import Tooltip from 'components/Tooltip/Tooltip';

const messages = defineMessages({
  search: { id: 'components.call.search', defaultMessage: 'Type the name or number' }
});

export class StartCallSearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      placeholderText: props.intl.formatMessage(messages.search),
      autoFocus: false
    };
    this.focus = this.focusHandler.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isFocused !== nextProps.isFocused) {
      this.props.handleSetIsFocused(nextProps.isFocused);
      this.setState({
        autoFocus: true
      });
    }
  }

  onKeyDown = (e) => {
    if (e.which !== 13 || !this.props.searchString || this.props.searchContacts.length) return;
    const searchString = this.props.searchString;
    const manualContact = {
      dialString: searchString,
      id: searchString,
      isManual: true,
      name: searchString
    };
    this.props.handleSelectContact(manualContact);
  };

  focusHandler() {
    this.props.handleSetIsFocused(true);
  }

  callInput = props =>
    ((props.contact && props.contact.id) ?
      <div className={classes.selectedCall}>
        <PillComp
          disabled={false}
          id={props.contact.id}
          onRemove={this.props.clearSelectedCall}
          value={props.contact}
        >
          {props.contact.name.length > 32 && <Tooltip label={props.contact.name} className={classes.wrapTooltip} />}
          <span className={classes.pillLabel}>{props.contact.name}</span>
        </PillComp>
      </div>
      :
      <input
        {...props.input}
        autoComplete="new-password"
        autoFocus={this.state.autoFocus}
        className={classes.callInput}
        maxLength={200}
        onFocus={this.focus}
        onKeyDown={this.onKeyDown}
        placeholder={this.state.placeholderText}
        type="text"
        data-testid="startCallSearch"
      />);

  render() {
    return (
      <div>
        <Field
          component={this.callInput}
          contact={this.props.contact}
          name={START_CALL_FORM}
          type="text"
        />
      </div>
    );
  }
}

StartCallSearchBar.propTypes = {
  clearSelectedCall: PT.func.isRequired,
  contact: PT.object,
  handleSelectContact: PT.func,
  handleSetIsFocused: PT.func.isRequired,
  intl: PT.object,
  isFocused: PT.bool,
  searchContacts: PT.array,
  searchString: PT.string
};

export default reduxForm({
  form: START_CALL_FORM,
  getFormState: state => state.app.form
})(injectIntl(StartCallSearchBar));
